// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__o3O5a","vLegacy":"SelectSecondary_vLegacy__1JnF3","error":"SelectSecondary_error__3sBS8","disabled":"SelectSecondary_disabled__37Rxo"};